import { render, staticRenderFns } from "./Section10.vue?vue&type=template&id=6fb1b02c&"
import script from "./Section10.vue?vue&type=script&lang=js&"
export * from "./Section10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports